<template>
  <div class="peoplemanagement">
    <!-- <router-view v-if="this.$route.path != '/personAdmin'" /> -->
    <div class="teachermanagement">
      <div class="teacher-head">
        <img
          class="headers people-manage-logo"
          src="../../assets/imgs/people.png"
        />
        <p class="headers people-manage-name cursorpoint">
          {{ $t('translateText.Personnelmanagement.Personnelmanagement') }}
        </p>
      </div>
      <div class="buttons">
        <div
          class="manage-teacher people-button cursorpoint"
          @click="teachermanages"
        >
          {{
            $t(
              'translateText.Personnelmanagement.TeacherManagement.TeacherManagement'
            )
          }}
        </div>
        <div
          class="manage-student people-button cursorpoint"
          @click="studentmanages"
        >
          {{
            $t(
              'translateText.Personnelmanagement.StudentManagement.StudentManagement'
            )
          }}
        </div>
      </div>
      <div class="peoplebutton">
        <div>
          <one-button @click="receiveadd">
            <a-icon type="plus-circle" />
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacher'
              )
            }}</one-button
          >
          <one-button @click="receivedelete">
            <i class="iconfont icon-shanchu1"></i>
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.BatchDeletion'
              )
            }}
          </one-button>
          <a-select
            v-model="queryParam.status"
            size="default"
            default-value="{ $t('translateText.TeacherManagement.EnableNoSpace') }"
            style="width: 98px; border-radius: 4px; margin-right: 16px"
            @change="handleChange"
          >
            <a-select-option :value="-1">{{
              $t('translateText.Personnelmanagement.TeacherManagement.All')
            }}</a-select-option>
            <a-select-option :value="0">{{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.Deactivate'
              )
            }}</a-select-option>
            <a-select-option :value="1">{{
              $t('translateText.Personnelmanagement.TeacherManagement.Enable')
            }}</a-select-option>
          </a-select>
          <one-button v-if="this.queryParam.status != 1" @click="receiveusing">
            <a-icon type="team" />
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.BatchActivation'
              )
            }}
          </one-button>
          <one-button
            v-if="this.queryParam.status != 0"
            @click="receiveisusing"
          >
            <a-icon type="usergroup-delete" />
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.BatchDeactivation'
              )
            }}
          </one-button>
          <!-- <one-button style="position: relative">
                        <a-icon type="usergroup-add" />
                        <input
                            @change="change"
                            multiple="multiple"
                            ref="upfile"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel "
                            style="
                                opacity: 0;
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                top: 0;
                                left: 0;
                                cursor: pointer;
                            "
                            type="file"
                        />
                        批量导入
                    </one-button> -->
          <!-- <one-button @click="download1">
                        <a-icon type="vertical-align-bottom" />
                        下载模板
                    </one-button> -->
        </div>
        <search
          class="headers select-manage-name"
          :placeholder="
            $t(
              'translateText.Personnelmanagement.TeacherManagement.PleaseEnterName'
            )
          "
          @search="onSearch"
          @zero="zero"
        ></search>
      </div>
      <!-- 教师列表 -->
      <div class="teachertable" ref="body">
        <publictable
          ref="table"
          class="people-table"
          :columns="people"
          :data2="teachers"
          :edit1="editor"
          :del="delets"
          :title="
            $t(
              'translateText.Personnelmanagement.TeacherManagement.DeleteThisTeacher'
            )
          "
          @getUserByRoleId="getUser"
          @userscope="confirmFn"
          :Show="true"
          @update="receive"
          @usercheckAll="usercheckAll"
          @receiveusing="receiveusing"
          @receiveisusing="receiveisusing"
        ></publictable>
      </div>
      <!-- 编辑教师 -->
      <a-modal
        ref="asd"
        v-model="showeditteacher"
        @ok="handleOk"
        @cancel="canceledit"
      >
        <div class="edit-roles">
          <p
            class="edit-title"
            :class="showaddusers == false ? 'disupdates' : 'updates'"
          >
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.AddTeacher'
              )
            }}
          </p>
          <p
            class="edit-title"
            :class="showaddusers == false ? 'adds' : 'disadds'"
          >
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.EditUser'
              )
            }}
          </p>
          <div class="public-left left-setrole"></div>
          <p class="headers public-setting setting-role">
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.BasicInformation'
              )
            }}
          </p>
          <div class="role-inform">
            <div class="role-inform-left">
              <p class="headers edit-role-name required">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.UserName'
                  )
                }}:
              </p>
              <p class="headers edit-role-note required">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.password'
                  )
                }}:
              </p>
              <p class="headers edit-role-class required">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Role'
                  )
                }}:
              </p>
            </div>
            <div class="role-inform-two">
              <input
                :disabled="showaddusers == true ? true : false"
                class="headers input-box role-identify"
                type="text"
                v-model="Name"
              />
              <input
                v-if="showaddusers"
                disabled
                class="headers sex-select"
                type="password"
                v-model="Password"
                value=""
              />
              <input
                v-else
                class="headers sex-select"
                type="text"
                v-model="Password"
                value=""
              />
              <a-select
                class="headers role-class"
                v-model="RoleName"
                :disabled="changeRoleName"
              >
                <!-- 只允许设置下级人员 -->
                <a-select-option
                  v-for="item in roles"
                  :key="item.iRoleId"
                  :disabled="handleChangeRoleName(item.iRoleId)"
                >
                  <!-- <a-select-option v-for="item in roles" :key="item.iRoleId" > -->
                  <!-- {{ item.strRoleName | txtFilters(item) }} -->
                  {{ txtFilters(item.strRoleName) }}
                </a-select-option>
              </a-select>
            </div>
            <div class="role-inform-right">
              <p class="headers edit-role-names required">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.RealName'
                  )
                }}:
              </p>
              <div
                v-if="showaddusers"
                style="
                  width: 100%;
                  height: 36%;
                  margin-top: 68%;
                  background-color: white;
                "
              >
                <button
                  :title="
                    $t(
                      'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.ResetPasswordTo'
                    )
                  "
                  @click="resetpassword"
                  class="headers edit-role-notes"
                  :disabled="changeresetpassword"
                >
                  {{
                    $t(
                      'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.ResetPassword'
                    )
                  }}
                </button>
              </div>
              <p class="headers edit-role-roles required">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Sex'
                  )
                }}:
              </p>
            </div>
            <div class="role-inform-three">
              <input
                class="headers input-box role-identifys"
                type="text"
                v-model="RealName"
                :disabled="changeRealName"
              />
              <a-select
                class="headers role-selects"
                v-model="Sex"
                default-value="{ $t('translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.PleaseSelect') }"
                :disabled="changesex"
              >
                <a-select-option :value="1">{{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Male'
                  )
                }}</a-select-option>
                <a-select-option :value="2">{{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Female'
                  )
                }}</a-select-option>
              </a-select>
            </div>
            <div class="line line-top"></div>
            <div class="line line-bottom"></div>
          </div>
          <div class="public-left left-privileges"></div>
          <p class="headers public-setting setting-privileges">
            {{
              $t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.ContactInformation'
              )
            }}
          </p>
          <div class="select-privileges">
            <div class="role-inform-bottom">
              <p class="headers edit-role-name">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Email'
                  )
                }}:
              </p>
              <p class="headers edit-role-note">
                {{
                  $t(
                    'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.PhoneNumber'
                  )
                }}:
              </p>
            </div>
            <div class="line line-center"></div>
            <input
              class="headers contact email"
              type="text"
              v-model="Email"
              :disabled="changeEmail"
            />
            <input
              class="headers contact phone"
              type="text"
              v-model="Phone"
              :disabled="changePhone"
            />
          </div>
        </div>
      </a-modal>
      <s-modal
        :visible="showdeleteroles"
        @cancel="cancelFn"
        @confirm="confirmFn"
      >
        {{
          $t(
            'translateText.Personnelmanagement.TeacherManagement.DeleteTheseTeacher'
          )
        }}
      </s-modal>
      <pag ref="pag" @passpage="passpage" />
    </div>
  </div>
</template>

<script>
import search from '@/components/search'
import pag from '@/components/pagiation'
import publictable from '@/components/Table/Table'
import sModal from '@/components/Modal/secondModal'
import json2csv from 'json2csv'
import CsvExportor from 'csv-exportor'
import {
  getUserByRoleId,
  AddUser,
  DelUser,
  UpdateUser,
  UpdateUserState,
  getPageRole,
  resetPassword,
} from '../../utils/api'
// import { TubeBufferGeometry } from 'three';

export default {
  name: 'PeopleManagement',
  data() {
    return {
      compile: false, //是否可编辑
      userinfo: {}, //用于存储从localStorage获取的用户信息
      pageNumber: '1',
      userdata: '',
      searchcontent: '',
      queryParam: { status: -1 },
      userarrs: [],
      // listPage,
      isCheckAll: false,
      showdeleteroles: false,
      showaddusers: false,
      changesex: false,
      changeRoleName: false,
      changePhone: false,
      changeEmail: false,
      changeresetpassword: false,
      changeRealName: false,
      showeditteacher: false,
      showimportdatas: 0,
      showdisusing: 0,
      showusing: 0,
      selectvalue: true,
      selectclickbgkcolor: 0,
      pagShow: true,

      bodyHeight: 0,
      selectedRowKeys: [], //当前选中列
      showuser: [],
      searchKey: '',
      editid: '',
      // teacherId:"",
      UserId: '',
      Name: '',
      RealName: '',
      Password: '',
      RoleName: '',
      defaultrolename: '',
      Sex: '',
      Phone: '',
      State: '',
      Email: '',

      teachers: [],
      roles: [],
      fields: ['name', 'realname', 'sex', 'phone'],
      json_fields: {
        用户名: 'name',
        姓名: 'realname',
        性别: 'sex',
        手机号: 'phone',
      },
      json_meta: [
        [
          {
            ' name ': ' charset ',
            ' value ': ' utf- 8 ',
          },
        ],
      ],
    }
  },
  computed: {
    people() {
      return [
        {
          title: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.NameOrId'
          ),
          dataIndex: 'name',
        },
        {
          title: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.Name'
          ),
          dataIndex: 'realname',
        },
        {
          title: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.Sex'
          ),
          dataIndex: 'sex',
          width: 120,
          align: 'center',
        },
        {
          title: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.Phone'
          ),
          dataIndex: 'phone',
        },
        //  {
        //   title: "启停状态",
        //   dataIndex: "status1",
        //    width:145,
        //   scopedSlots: { customRender: "state1" },
        // },
        {
          title: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.StartStopSettings'
          ),
          dataIndex: 'status',
          width: 145,
          scopedSlots: { customRender: 'state' },
          // filters: [
          //     { text: '停用', value: '0' },
          //     { text: '启用', value: '1' },
          // ],
          filterMultiple: false,
          onFilter: (value) => {
            console.log(value)
          },
        },

        {
          title: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.operation'
          ),
          dataIndex: 'op',
          scopedSlots: { customRender: 'op' },
        },
      ]
    },
    editor() {
      return this.$t('translateText.Personnelmanagement.TeacherManagement.Edit')
    },
    delets() {
      return this.$t(
        'translateText.Personnelmanagement.TeacherManagement.Delete'
      )
    },
    sexs() {
      return [
        {
          name: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Male'
          ),
        },
        {
          name: this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Female'
          ),
        },
      ]
    },

    categories() {
      return this.queryParam.status
    },
    selectedRowKey() {
      return this.selectedRowKeys.length > 0
    },
    search() {
      return this.searchKey.length
    },
    // categories() {
    //     return this.queryParam.status;
    // },
  },

  watch: {
    categories(val) {
      if (val == 0) {
        this.status = this.$t(
          'translateText.Personnelmanagement.TeacherManagement.Deactivate'
        )
        // this.status1 = "停用";
      } else if (val == 1) {
        this.status = this.$t(
          'translateText.Personnelmanagement.TeacherManagement.Enable'
        )
        // this.status1 = "启用";
      }
      // if (val == 0) {
      //   this.status = "停用";
      // } else if (val == 1) {
      //   this.status = "启用";
      // }
    },
  },
  methods: {
    txtFilters(item) {
      if (item == '超级管理员') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.SuperAdministrator'
        )
      } else if (item == '管理') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.Administrator'
        )
      } else if (item == '教师') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.Teacher'
        )
      } else if (item == '学生') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.Student'
        )
      }
      console.log(item)
    },
    // 设置管理下级人员
    handleChangeRoleName(roleid) {
      this.userinfo = this.$store.state.userinfo.role.iRoleId
      if (roleid < this.userinfo || roleid == this.userinfo) {
        return true
      }
      return false
    },
    resetpassword() {
      resetPassword(this.UserId).then((response) => {
        if (response.data.iCode == 0) {
          return (
            this.$message.success(
              this.$t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.ResetSuccessful'
              )
            ),
            (this.showeditteacher = false)
          )
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    passpage(pageNumber) {
      this.pageNumber = pageNumber
      this.getUser()
    },
    //查询用户
    getUser() {
      getUserByRoleId({
        iRoleId: '1',
        strUserName: '',
        strRealName: this.searchcontent,
        iUserState: this.queryParam.status,
        iClassId: 0,
        iCurPage: this.pageNumber,
        iPageSize: 10,
      }).then((response) => {
        if (response.data.iCode == 0) {
          this.teachers = []
          this.userarrs = response.data.objData.listPage
          console.log(this.$store.state.userinfo)
          if (this.$store.state.userinfo.role.iRoleId !== 1)
            this.userarrs = this.userarrs.filter((item) => {
              return item.role.iRoleId !== 1
            })
          this.$refs.pag.showTotal = response.data.objData.iTotalPages * 10
          this.$refs.pag.pageNumber = response.data.objData.iPageIndex
          sessionStorage.setItem(
            'showTotal',
            response.data.objData.iTotalPages * 10
          )
          sessionStorage.setItem('pageNumber', response.data.objData.iPageIndex)
          for (let i = 0; i < this.userarrs.length; i++) {
            let teacher = {
              id: '',
              key: '',
              name: '',
              realname: '',
              sex: '',
              phone: '',
              status: '',
              // status1: "",
              email: '',
              roleid: '',
              rolename: '',
            }
            teacher.id = this.userarrs[i].iUserId
            teacher.key = this.userarrs[i].iUserId
            teacher.name = this.userarrs[i].strUserName
            teacher.realname = this.userarrs[i].strRealName
            teacher.sex =
              this.userarrs[i].ddUserSex.iNumber == 1
                ? this.$t(
                    'translateText.Personnelmanagement.TeacherManagement.Male'
                  )
                : this.$t(
                    'translateText.Personnelmanagement.TeacherManagement.Female'
                  )
            teacher.sexNumber = this.userarrs[i].ddUserSex.iNumber
            teacher.phone = this.userarrs[i].strUserPhone
            teacher.status = this.userarrs[i].ddUserState.iNumber
            // teacher.status1 = this.userarrs[i].ddUserState.iNumber;
            teacher.email = this.userarrs[i].strUserEmail
            teacher.roleid = this.userarrs[i].role.iRoleId
            teacher.rolename = this.userarrs[i].role.strRoleName
            this.teachers.push(teacher)
          }
        } else {
          return this.$message.error(response.data.strMessage)
        }

        // this.teachers = teacherarr
      })
    },
    handleChange(item) {
      this.$refs.table.selectedRowKeys = []
      this.selectedRowKeys = []
      this.queryParam.status = item
      this.pageNumber = 1
      this.getUser()
    },
    //下载模板
    download1() {
      let tableData = [
        {
          name: '',
          realname: '',
          sex: '',
          phone: '',
        },
      ]
      let header = ['用户名', '姓名', '性别', '手机号']
      CsvExportor.downloadCsv(tableData, { header }, 'test.csv')
    },
    download() {
      try {
        const result = json2csv.parse(this.teachers, {
          fields: this.fields,
          excelStrings: true,
        })
        if (this.MyBrowserIsIE()) {
          // IE10以及Edge浏览器
          var BOM = '\uFEFF'
          // 文件转Blob格式
          var csvData = new Blob([BOM + result], {
            type: 'text/csv',
          })
          navigator.msSaveBlob(csvData, `a.csv`)
        } else {
          let csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + result
          // 非ie 浏览器
          this.createDownLoadClick(csvContent, `a.csv`)
        }
      } catch (err) {
        alert(err)
      }
    },
    //批量导入
    Render() {
      debugger
      let that = this
      let obj = {}
      let keys = this.teachers.length + 1
      this.listPage.forEach((item, index) => {
        obj.key = keys + index
        obj.name = item.strUserName
        obj.realname = item.strRealName
        obj.sex = item.ddUserSex.strContext
        obj.phone = item.strUserPhone
        obj.class = item.userClass.strClassName
        // obj.status = item.ddUserState.strContext;
        obj.status = '1'
        that.teachers.push(JSON.parse(JSON.stringify(obj)))
      })
    },
    //回调函数
    change() {
      // let file = e.target.files;
      // for (let i = 0; i < file.length; i++) {
      //     if (
      //         file[i].name.includes(".xls") ||
      //         file[i].name.includes(".xlsx")
      //     ) {
      //         this.$refs.upfile.value = "";
      //         this.$message.success("导入文件完成");
      //         this.Render();
      //         return false;
      //     } else {
      //         this.$refs.upfile.value = "";
      //         return this.$message.error(
      //             "请导入文件格式为.xls或.xlsx的文件"
      //         );
      //     }
      // }
    },
    //全选
    usercheckAll(val) {
      this.selectedRowKeys = val
    },
    //页面跳转
    teachermanages() {
      this.$router.push('/personAdmin')
    },
    studentmanages() {
      this.$router.push('/personAdmin/studentManagement')
    },
    //编辑
    receive(row) {
      this.userinfo = this.$store.state.userinfo.role.iRoleId

      if (
        this.userinfo != 1 &&
        (row.roleid < this.userinfo || row.roleid == this.userinfo)
      ) {
        this.changesex = true
        this.changeresetpassword = true
        this.changeRoleName = true
        this.changePhone = true
        this.changeEmail = true
        this.changeRealName = true
      } else {
        this.changeRealName = false
        this.changeRoleName = false
        this.changePhone = false
        this.changesex = false
        this.changeresetpassword = false
        this.changeEmail = false
      }

      this.userdata = row
      this.showeditteacher = true
      this.showaddusers = true
      this.UserId = this.userdata.id
      this.Name = this.userdata.name
      this.RealName = this.userdata.realname
      this.Sex = this.userdata.sexNumber
      this.RoleName = this.userdata.roleid
      // this.RoleId = this.userdata.roleid
      this.Password = '123456'
      this.Phone = this.userdata.phone
      this.Email = this.userdata.email

      let vm = this
      getPageRole({
        strRoleName: '',
        iCurPage: 1,
        iPageSize: 100,
      }).then(function(response) {
        vm.roles = response.data.objData.listPage
        vm.roles = vm.roles.filter(
          (item) =>
            item.strRoleName != '学生'
        )
        // vm.roles.dtCreateTime = vm.getdate(
        //     response.data.objData.listPage.dtCreateTime
        // );
      })
      // this.
    },
    //添加用户
    receiveadd() {
      this.changeRealName = false
      this.changeRoleName = false
      this.changePhone = false
      this.changesex = false
      this.changeresetpassword = false
      this.changeEmail = false
      this.showeditteacher = true
      this.showaddusers = 0
      this.Name = ''
      this.RealName = ''
      this.Sex = ''
      // this.RoleName = row.ddUserState.strContext
      this.Password = ''
      this.Phone = ''
      this.Email = ''
      this.RoleName = ''
      let vm = this
      getPageRole({
        strRoleName: '',
        iCurPage: 1,
        iPageSize: 100,
      }).then(function(response) {
        vm.roles = response.data.objData.listPage
        console.log(vm.roles)
        vm.roles = vm.roles.filter(
          (item) =>
            item.strRoleName != '学生'
        )
        // vm.roles.dtCreateTime = vm.getdate(
        //     response.data.objData.listPage.dtCreateTime
        // );
      })
    },
    showModal() {
      this.showeditteacher = true
    },
    // 添加或完成编辑确定按钮
    handleOk() {
      var reg = /^(\+86)?(13|15|17|18|14)\d{9}$/;
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.Name == "" ||  this.Name.split(" ").join("").length ==0) {
        return this.$message.error(this.$t('translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.UserNameNotEmpty'));
      } else if (this.RealName == "" ||  this.RealName.split(" ").join("").length ==0) {
        return this.$message.error(this.$t('translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NameNotEmpty'));
      } else if (this.Password == "" ||  this.Password.split(" ").join("").length ==0) {
        return this.$message.error(this.$t('translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.PasswordNotEmpty'));
      } else if (this.Sex == "") {
        return this.$message.error(this.$t('translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.SelectGender'));
      } else if (this.RoleName == "") {
        return this.$message.error(this.$t('translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.SelectRole'));
      } else if (this.Phone && !reg.test(this.Phone) && this.$i18n.locale == 'zh') {
        return this.$message.error(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.IncorrectPhonEFormat'
          )
        )
      } else if (this.Email && !regEmail.test(this.Email)) {
        return this.$message.error(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.IncorrectEmailFormat'
          )
        )
      }
      
      if (this.showaddusers == false) {
        AddUser({
          user: {
            strUserName: this.Name,
            strRealName: this.RealName,
            strUserPassword: this.Password,
            ddUserSex: {
              iNumber: this.Sex,
            },
            userClass: {
              iClassId: 0,
            },
            strUserPhone: this.Phone,
            strUserEmail: this.Email,
            strUserImgUrl: '',
            ddUserState: {
              iNumber: 1,
            },
          },
          listRoleId: [this.RoleName],
        }).then((response) => {
          if (response.data.iCode != 0) {
            if (response.data.strMessage == '已有此用户名或手机号') {
              return this.$message.error(this.$t('translateText.gl.zysj'))
            } else {
              return this.$message.error(response.data.strMessage)
            }
          } else {
            this.showeditteacher = false
            this.searchcontent = ''
            this.getUser()
          }
        })
      } else if (this.showaddusers == true) {
        this.userinfo = this.$store.state.userinfo.role.iRoleId
        if (this.userinfo != 1) {
          if (this.RoleName < this.userinfo || this.RoleName == this.userinfo) {
            return this.$message.error(
              this.$t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NoPermissionToOperate'
              )
            )
          }
        }
        UpdateUser({
          user: {
            iUserId: this.UserId,
            strRealName: this.RealName,
            ddUserSex: {
              iNumber: this.Sex,
            },
            userClass: {
              iClassId: 0,
            },
            strUserPhone: this.Phone,
            strUserEmail: this.Email,
          },
          listRoleId: [this.RoleName],
        }).then((response) => {
          if (response.data.iCode != 0) {
            if(response.data.iCode == 1000){
              return this.$message.error(this.$t('translateText.accountSet.NumberExists'))
            }
            return this.$message.error(response.data.strMessage)
          } else {
            this.showeditteacher = false
            this.$message.success(
              this.$t(
                'translateText.Personnelmanagement.TeacherManagement.xgcg'
              )
            )
            this.getUser()
            if (this.userinfo.iUserId == response.data.objData.iUserId) {
              //判断是否时更改的自己的账号，如果是将更改信息保存至浏览器用于账号设置
              this.userinfo.strUserName = this.Name
              this.userinfo.strRealName = this.RealName
              this.userinfo.ddUserSex.iNumber = this.Sex
              this.userinfo.strUserPhone = this.Phone
              this.userinfo.strUserEmail = this.Email
              // var userinfo = JSON.stringify(this.userinfo)
              // localStorage.setItem("userinfo",userinfo);
              this.$store.commit('getUserInfo', this.userinfo)
            }
          }
        })
      }
    },
    canceledit() {
      this.showeditteacher = false
      this.colorone = false
    },
    //删除
    receivedelete() {
      if (this.selectedRowKey) {
        this.showdeleteroles = true
        return false
      }
      return this.$message.error(
        this.$t(
          'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NotSelected'
        )
      )
    },
    cancelFn() {
      this.showdeleteroles = false
    },
    confirmFn() {
      let arr2 = this.selectedRowKeys.map((item) => {
        return Object.assign(
          {},
          { iUserId: item.id, strRealName: item.name, roleid: item.roleid }
        )
      })
      this.userinfo = this.$store.state.userinfo.role.iRoleId

      if (this.userinfo != 1) {
        if (arr2[0].roleid < this.userinfo || arr2[0].roleid == this.userinfo) {
          return this.$message.error(
            this.$t(
              'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NoPermissionToOperate'
            )
          )
        }
      }

      let exists = this.selectedRowKeys.some((item) => {
        if (item.id == this.userinfo.iUserId) return true
      })

      if (exists) {
        return this.$message.error(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.DeleteOwnAccount'
          )
        )
      } else {
        DelUser(arr2).then((response) => {
          if (response.data.iCode == 0) {
            this.showdeleteroles = false
            var pageNum = this.$refs.pag.showTotal / 10
            if (
              pageNum == this.pageNumber &&
              this.teachers.length == arr2.length
            ) {
              this.pageNumber--
              if (this.pageNumber == 0) {
                this.pageNumber = 1
              }
            }
            this.getUser()
            this.selectedRowKeys = []
          } else if(response.data.iCode == 1000){
            return this.$message.error(this.$t(
            'translateText.Personnelmanagement.StudentManagement.NameHasUsed'
          ))
        } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      }
    },
    delFn() {
      this.showdeleteroles = true
    },
    //批量启用
    receiveusing() {
      if (this.selectedRowKey) {
        let arr2 = this.selectedRowKeys.map((item) => {
          return Object.assign(
            {},
            {
              iUserId: item.id,
              ddUserState: { iNumber: 1 },
              roleid: item.roleid,
            }
          )
        })
        this.userinfo = this.$store.state.userinfo.role.iRoleId
        if (this.userinfo != 1) {
          if (
            arr2[0].roleid < this.userinfo ||
            arr2[0].roleid == this.userinfo
          ) {
            return this.$message.error(
              this.$t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NoPermissionToOperate'
              )
            )
          }
        }
        UpdateUserState(arr2).then((response) => {
          if (response.data.iCode == 0) {
            this.$refs.table.selectedRowKeys = []
            if (this.queryParam.status != -1) {
              this.teachers = this.teachers.filter(
                (item) => !this.selectedRowKeys.includes(item)
              )
            } else {
              for (var i = 0; i < this.selectedRowKeys.length; i++) {
                for (var j = 0; j < this.teachers.length; j++) {
                  if (this.teachers[j].key == this.selectedRowKeys[i].key) {
                    this.teachers[j].status = 1
                    continue
                  }
                }
              }
            }
            this.getUser()
            this.selectedRowKeys = []
          } else {
            return this.$message.error(response.data.strMessage)
          }
        })
      } else {
        return this.$message.error(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NotSelected'
          )
        )
      }
      // var pageNum = this.$refs.pag.showTotal/10
      // if(pageNum==this.pageNumber && this.selectedRowKeys.length==this.teachers.length){
      //           this.pageNumber--
      //           if(this.pageNumber==0){
      //             this.pageNumber = 1
      //           }
      //             this.getUser()
      //       }
    },
    //批量停用
    receiveisusing() {
      console.log('hhhhhhhhhhh')
      console.log(this.selectedRowKeys)
      if (this.selectedRowKey) {
        let arr2 = this.selectedRowKeys.map((item) => {
          return Object.assign(
            {},
            {
              iUserId: item.id,
              ddUserState: { iNumber: 0 },
              roleid: item.roleid,
            }
          )
        })
        this.userinfo = this.$store.state.userinfo.role.iRoleId
        if (this.userinfo != 1) {
          if (
            arr2[0].roleid < this.userinfo ||
            arr2[0].roleid == this.userinfo
          ) {
            return this.$message.error(
              this.$t(
                'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NoPermissionToOperate'
              )
            )
          }
        }
        let exists = this.selectedRowKeys.some((item) => {
          if (item.id == this.userinfo.iUserId) return true
        })

        if (exists) {
          return this.$message.error(
            this.$t(
              'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.DeactivateOwnAccount'
            )
          )
        } else {
          UpdateUserState(arr2).then((response) => {
            if (response.data.iCode == 0) {
              this.$refs.table.selectedRowKeys = []
              if (this.queryParam.status != -1) {
                this.teachers = this.teachers.filter(
                  (item) => !this.selectedRowKeys.includes(item)
                )
              } else {
                for (var i = 0; i < this.selectedRowKeys.length; i++) {
                  for (var j = 0; j < this.teachers.length; j++) {
                    if (this.teachers[j].key == this.selectedRowKeys[i].key) {
                      this.teachers[j].status = 0
                      continue
                    }
                  }
                }
              }
              this.getUser()
              this.selectedRowKeys = []
            } else {
              return this.$message.error(response.data.strMessage)
            }
          })
        }
      } else {
        return this.$message.error(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.NotSelected'
          )
        )
      }

      // var pageNum = this.$refs.pag.showTotal/10
      // if(pageNum==this.pageNumber && this.selectedRowKeys.length==this.teachers.length){
      //           this.pageNumber--
      //           if(this.pageNumber==0){
      //             this.pageNumber = 1
      //           }
      //             this.getUser()
      //       }
    },
    //搜索用户
    onSearch(val) {
      this.pageNumber = 1
      this.searchcontent = val

      this.getUser()
    },
    zero() {
      this.searchKey = ''
    },
    searchuser(val) {
      this.searchKey = val
      this.showuser = []
      this.teachers.forEach((item) => {
        if (item.realname.indexOf(val) != -1 || item.name.indexOf(val) != -1) {
          this.showuser.push(item)
        }
      })
      if (this.showuser.length != '0') {
        this.teachers = []
        this.teachers = this.showuser
        return this.$message.success(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Found'
          ) +
            this.showuser.length +
            this.$t(
              'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.Teachers'
            )
        )
      } else {
        return this.$message.error(
          this.$t(
            'translateText.Personnelmanagement.TeacherManagement.AddTeacherPage.TeacherFound'
          )
        )
      }
    },
  },
  filters: {
    txtFilters(item) {
      if (item == '超级管理员') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.SuperAdministrator'
        )
      } else if (item == '管理') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.Administrator'
        )
      } else if (item == '教师') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.Teacher'
        )
      } else if (item == '学生') {
        return this.$t(
          'translateText.Personnelmanagement.StudentManagement.AddPages.Student'
        )
      }
      console.log(item)
    },
  },
  mounted() {
    this.bodyHeight = this.$refs.body.offsetHeight - 60
    this.getUser()
    this.userinfo = this.$store.state.userinfo
  },
  components: {
    pag,
    publictable,
    sModal,
    search,
  },
}
</script>

<style lang="stylus" scoped>
.required {
  &::before {
    content: '*';
    color: red;
    margin-left: -8px;
  }
}
/deep/.ant-table-tbody > tr > td {
    padding: 9.5px 13px;
}
.peoplemanagement {
  width: 100%;
  height: 100%;
}

input {
  outline: none;
}

.headers {
  border-radius: 4px;
  display: inline-block;
  position: absolute;
}

.header {
  display: inline-block;
  text-align: left;
  margin-top: 18px;
}

.body-header {
  display: inline-block;
  text-align: left;
  margin-top: 0;
}

.on {
  background: rgba(230, 245, 246, 0.5);
  // opacity: 0.5
}

.off {
  background: #FFFFFF;
  border-radius: 5px;
}

.adds {
  visibility: hidden;
}

.disadds {
  visibility: visible;
}

.updates {
  visibility: hidden;
}

.disupdates {
  visibility: visible;
}

.onstate {
  background: #1AA97B;
}

.offstate {
  background: #F9463F;
}

.bgkbutton {
  background: #2EADB5;
  color: #FFFFFF;
}

.defaultbutton {
  background: #FFFFFF;
  color: #2EADB5;
}

.cursorpoint {
  cursor: pointer;
}

.teachermanagement {
  // text-decoration-color position: relative
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  border-radius: 5px;
  position: relative;

  .teacher-head {
    width: 90%;
    height: 6%;
    font-size: 17px;
    letter-spacing: 2px;
    font-weight: 700;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    // padding-top: 2.5%
    position: absolute;
    top: 1.22%;
    left: 2%;
  }

  .people-manage-logo {
    width: 1.62%;
    height: 50%;
  }

  .people-manage-name {
    font-size: 2.22222222222vh;
    font-weight: 700;
    margin-left: 2.6%;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    width: 95%;
    height: 39px;
    border-bottom: 1px solid #D6D6D6;
    position: absolute;
    top: 7%;
    left: 2%;
  }

  .people-button {
    width: 10%;
    height: 39px;
    line-height: 39px;
  }

  .manage-teacher {
    background: #FFFFFF;
    border: 1px solid #D6D6D6;
    border-radius: 4px 4px 0px 0px;
    color: #2FAEB6;
  }

  .manage-student {
    margin-left: 10px;
    background: #E5E5E5;
    border: 1px solid #D6D6D6;
    border-radius: 4px 4px 0px 0px;
    color: #4A4A4A;
  }

  .peoplebutton {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 95%;
    position: absolute;
    left: 2%;
    top: 14%;

    .select-manage-name {
      width: 19.52%;
      margin-left: 81%;
    }

    /deep/.ant-select-selection:hover {
      border-color: #2eadb5;
      // background-color :#2eadb5
      // color:white
    }

    /deep/.ant-select-selection {
      border: 1px solid #2eadb5;
      color: #2EADB5;
      box-shadow: 0 0 0 0;
    }

    /deep/.ant-select-arrow-icon {
      color: #2eadb5;
    }

    /deep/.ant-select-selection-selected-value {
      width: 100%;
    }
  }
}

.teachertable {
  position: absolute;
  top: 21%;
  right: 2%;
  left: 2%;
  // bottom: 10%;
      bottom:48px;
    overflow: auto;
}
 .teachertable::-webkit-scrollbar {
  display: none;
}

.people-table {
  display: block;
  // margin-top: 2.1%;
  // margin-left: 2%;
  width: 99%;
  height: 62%;
}

.tb-bd {
  display: inline-block;
  width: 100%;
}

/deep/.ant-modal-content {
  display: inline-block;
  width: 500px;
  height: 450px;
  margin-left: 8%;
  margin-top: 4%;
}

/deep/.ant-modal .ant-modal-content .ant-modal-footer {
  border-top: none;
  margin-top: 340px;
}

/deep/.ant-btn {
  transition: none !important;
}

/deep/.ant-btn-primary {
  background: #2EADB5;
  margin-right: 26%;
  margin-left: 18%;
}

.edit-roles {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.edit-title {
  diaplay: inline-block;
  position: absolute;
  top: 1%;
  left: 50%;
  transform: translateX(-50%);
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #4E4E4E;
  line-height: 58px;
  font-size: 2.05185185185vh;
}

.setting-role {
  top: 8.02%;
}

.public-setting {
  left: 6%;
  font-size: 1.7vh;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #2EADB5;
  line-height: 41px;
}

.left-setrole {
  top: 11.3%;
}

.public-left {
  width: 4px;
  height: 10px;
  position: absolute;
  left: 4%;
  background: #2EADB5;

  @media screen and (max-height: 1100px) and (max-width: 900px) {
    height: 12px;
  }

  @media screen and (min-height: 1200px) and (min-width: 1000px) {
    height: 16px;
  }
}

.line {
  position: absolute;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background: #D5D5D5;
}

.input-box {
  border: 1px solid #D5D5D5;
  width: 86%;
}

.role-inform {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 16.42%;
  width: 93%;
  height: 36.345%;
  border: 1px solid #D5D5D5;

  .role-inform-left {
    width: 16.34%;
    height: 100%;
    margin-left: 0;
    background: #F5F5F5;
    font-size: 12px;
  }

  .line-top {
    top: 33%;
  }

  .line-bottom {
    top: 68.6%;
  }

  .edit-role-name {
    top: 9.5%;
    left: 3%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.3666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.3666666666vh;
    }
  }

  .edit-role-note {
    top: 44.5%;
    left: 3%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.3666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.3666666666vh;
    }
  }

  .edit-role-class {
    left: 3%;
    top: 79%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.3666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.3666666666vh;
    }
  }

  .role-inform-two {
    position: absolute;
    top: 0;
    left: 16%;
    width: 33.66%;
    height: 100%;

    .role-class {
      left: 5%;
      top: 75.6%;
      height: 19%;
      width: 86%;
      border: 1px solid #D5D5D5;
      border-radius: 4px;
    }

    /deep/.ant-select-selection--single {
      height: 29px;
      border: none;
      outline: none;
    }

    .sex-select {
      top: 41.4%;
      left: 5%;
      border: 1px solid #D5D5D5;
      height: 19%;
      width: 86%;
    }
  }

  .role-identify {
    top: 7%;
    left: 5%;
    height: 19%;
  }

  .role-inform-right {
    position: absolute;
    top: 0;
    right: 34%;
    width: 16.34%;
    height: 100%;
    background: #F5F5F5;
    font-size: 12px;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 12px;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 12px;
    }

    .edit-role-names {
      top: 11.5%;
      left: 17%;
    }

    .edit-role-notes {
      top: 40%;
      // left: 7%
      background-color: #2eadb5;
      border: #2eadb5;
      color: white;
      width: 99%;
      height: 22%;
    }

    .edit-role-roles {
      top: 79%;
      left: 17%;
    }
  }

  .role-inform-three {
    position: absolute;
    top: 0;
    right: 0;
    width: 33.66%;
    height: 100%;

    .role-identifys {
      top: 7%;
      left: 5%;
      height: 19%;
    }

    .role-noteinfor {
      top: 41%;
      left: 5%;
      height: 19%;
      width: 86%;
    }

    .role-selects {
      top: 74%;
      left: 5%;
      height: 19%;
      width: 86%;
    }
  }
}

.setting-privileges {
  top: 53.22%;
}

.left-privileges {
  top: 56.5%;

  @media screen and (max-height: 1100px) and (max-width: 900px) {
    top: 56.2%;
  }

  @media screen and (min-height: 1200px) and (min-width: 1000px) {
    top: 55.2%;
  }
}

.select-privileges {
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
  width: 93%;
  height: 23.345%;
  border: 1px solid #D5D5D5;

  .role-inform-bottom {
    width: 16.34%;
    height: 100%;
    margin-left: 0;
    background: #F5F5F5;
    font-size: 12px;
  }

  .contact {
    width: 40%;
    height: 30%;
    left: 20%;
    border: 1px solid #D5D5D5;
    font-size: 1.66666666vh;
    color: #6E6E6E;
  }

  .email {
    top: 11%;
  }

  .phone {
    top: 62%;
  }

  .line-center {
    top: 50%;
  }

  .edit-role-name {
    top: 15%;
    left: 3%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      left: 1.8%;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      left: 1.8%;
    }
  }

  .edit-role-note {
    top: 67%;
    left: 3%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      left: 1.8%;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      left: 1.8%;
    }
  }
}

.setting-button {
  position: absolute;
  bottom: 4.5%;
}

.setting-concel {
  left: 34%;
  color: #2eadb5;
  border: 1px #2eadb5 solid;
}

.setting-sure {
  right: 34%;
  background-color: #2eadb5;
  border: #2eadb5;
  color: #FFFFFF;
}

.line-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background: #D5D5D5;
}

.edit-role-name {
  top: 19%;
  left: 3%;

  @media screen and (max-height: 1100px) and (max-width: 900px) {
    font-size: 1.3666666666vh;
    left: 1.8%;
  }

  @media screen and (min-height: 1200px) and (min-width: 1000px) {
    font-size: 1.3666666666vh;
    left: 1.8%;
  }
}

.edit-role-note {
  top: 69%;
  left: 3%;

  @media screen and (max-height: 1100px) and (max-width: 900px) {
    font-size: 1.3666666666vh;
    left: 1.8%;
  }

  @media screen and (min-height: 1200px) and (min-width: 1000px) {
    font-size: 1.3666666666vh;
    left: 1.8%;
  }
}
</style>
